import { ePropertyCondition } from '@/app/globalContext/globalContext.interfaces';

const CLP_CURRENCY_TYPE = 1;

// Esta regla ("mostrar primero la moneda que eligió el cliente al publicar") solo aplica a
// propiedades usadas. Las nuevas (proyectos) siempre muestran UF primero, sin importar currencyType.
export const shouldShowNativeCurrencyFirst = (idEstadoPropiedad?: number): boolean => {
	return idEstadoPropiedad === ePropertyCondition.used;
};

export const getNativePricePrefix = (currencyType?: number): 'UF' | '$' => {
	return currencyType === CLP_CURRENCY_TYPE ? '$' : 'UF';
};

// precios siempre llega del backend como [UF, $] (ver apps/api/src/propiedades/utils/getPrice.ts).
// Para propiedades usadas, reordena para que la moneda nativa quede primero (value 0 = primario).
export const getOrderedPrecios = <T extends { prefix: string }>(
	precios: T[] | undefined,
	currencyType: number | undefined,
	idEstadoPropiedad: number | undefined,
): T[] => {
	if (!precios?.length || !shouldShowNativeCurrencyFirst(idEstadoPropiedad)) return precios ?? [];

	const nativePrefix = getNativePricePrefix(currencyType);
	const native = precios.find((p) => p.prefix === nativePrefix);
	const other = precios.find((p) => p.prefix !== nativePrefix);

	return native && other ? [native, other] : precios;
};

// El CardPropiedad de @toctoc/design-system (no editable) muestra en tamaño grande
// precios[1] cuando tipoOperacion es "arriendo", y precios[0] en cualquier otro caso.
// Para que la moneda nativa siempre caiga en el slot grande, hay que compensar ese swap.
export const getPreciosForCardPropiedad = <T extends { prefix: string }>(
	precios: T[] | undefined,
	currencyType: number | undefined,
	idEstadoPropiedad: number | undefined,
	tipoOperacion: string | undefined,
): T[] => {
	if (!precios?.length || !shouldShowNativeCurrencyFirst(idEstadoPropiedad)) return precios ?? [];

	const nativePrefix = getNativePricePrefix(currencyType);
	const native = precios.find((p) => p.prefix === nativePrefix);
	const other = precios.find((p) => p.prefix !== nativePrefix);
	if (!native || !other) return precios;

	const isArriendo = tipoOperacion?.toLowerCase() === 'arriendo';
	return isArriendo ? [other, native] : [native, other];
};
